/**
 * Authentication Layout
 * Layout for public authentication pages (login, register, forgot password, etc.)
 *
 * Features:
 * - Centered card design (max-width 400px)
 * - Dark-mode background
 * - Mensova logo with dark mode support
 * - Copyright footer
 * - Responsive: full-width on mobile, centered on desktop
 */

import { Box, Paper, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AuthLogo } from '@/components/layout/AuthLogo';
import { APP_NAME } from '@/constants/brand';

/**
 * Auth Layout
 * Centered card layout for authentication pages
 */
export const AuthLayout: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        px: 2,
        py: 4,
      }}
    >
      {/* Main Content Card */}
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 400,
          p: 4,
          borderRadius: 2,
        }}
      >
        {/* Logo/Brand Section */}
        <Box
          sx={{
            mb: 4,
            textAlign: 'center',
          }}
        >
          <AuthLogo height={48} showLabel={false} />
        </Box>

        {/* Auth page content (Login, Register, etc.) */}
        <Outlet />
      </Paper>

      {/* Copyright Footer */}
      <Typography
        variant="caption"
        sx={{
          mt: 4,
          color: 'text.secondary',
        }}
      >
        © {currentYear} {APP_NAME}
      </Typography>
    </Box>
  );
};
